import { render, staticRenderFns } from "./DeleteCardModal.vue?vue&type=template&id=506ee258&scoped=true&"
import script from "./DeleteCardModal.vue?vue&type=script&lang=js&"
export * from "./DeleteCardModal.vue?vue&type=script&lang=js&"
import style0 from "./DeleteCardModal.vue?vue&type=style&index=0&id=506ee258&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506ee258",
  null
  
)

export default component.exports